import { registrarAcao } from '@/shared/utils/reportAction';
import { reportError } from '@/shared/utils/reportError';

import type { ErroDaSimulacao, ContextoDaFalha } from '../types';
import { FalhaDaSimulacao } from './services';

/**
 * Falha de rede e "Sessão expirada" do requestBuilder chegam como `Error` comum: status 0 separa
 * "nem chegou ao core" (desfecho desconhecido, retry com a mesma chave) de uma recusa do core.
 */
export const paraErroDaSimulacao = (erro: unknown): ErroDaSimulacao =>
  erro instanceof FalhaDaSimulacao
    ? erro.erro
    : {
        status: 0,
        codigo: null,
        mensagem: 'Não foi possível falar com o servidor. Verifique a conexão e tente novamente.',
        camposInvalidos: [],
        comandoId: null,
      };

/**
 * Recusa prevista do core (4xx com código) é desfecho, não erro: vai para `registrarAcao`. Rede e
 * 5xx vão para `reportError`. Só ids, status e código: texto e parâmetros nunca saem do browser.
 */
export const registrarFalha = (
  acao: string,
  original: unknown,
  falha: ErroDaSimulacao,
  ids: ContextoDaFalha,
) => {
  const contexto = { acao, status: falha.status, codigo: falha.codigo, ...ids };
  if (falha.status === 0 || falha.status >= 500) {
    const erro = original instanceof Error ? original : new Error(falha.mensagem);
    reportError(erro, { source: 'negociacaoSimulacao', ...contexto });
    return;
  }
  registrarAcao('negociacaoSimulacao.comandoRecusado', contexto);
};
